module.exports = __webpack_public_path__ + "static/img/pixiu@2x.a6e7af1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/pixiu@2x.png
// module id = 1VYz
// module chunks = 2